export default {
    ding_app_name: 'DING Booking System',
    message: {
        items_automatically_added_to_cart: 'The following items have been automatically added to your cart:<br>{items}',
        please_select_booking_date_time_to_calculate: 'Amount will update after selecting booking date',
        login_phone_placeholder: 'Enter your mobile phone number',
        you_have_logged_in_welcome: 'You\'ve logged in. Welcome.',
        gray_out_means_not_available: 'Gray out means not available',
        fail_to_get_order: 'Fail to get order data',
        please_select_custom_first: "Please select {custom} first",
        please_select_end_date_first: "Please select end time first",
        sorry_copy_failed: 'Sorry, fail to copy in your browser. Please copy by yourself.',
        atm_reported: '(account reported)',
        please_login_to_proceed_booking: 'Please login to complete booking',
        are_you_sure_to_delete_image: "Are pyou sure to delete option image?",
        cart_payment_method: "Payment Method",
        sorry_fail_to_check_bookings: 'Sorry, fail to check bookings/leaves.',
        min_n_items_required: "Minimum {n} item(s) required",
        max_n_items_exceeded: "Maximum {n} item(s) exceeded",
        cart_logistic: "Delivery",
        please_select_items: "Please select items to purchase",
		cart: "Checkout Items",
        is_preview_cant_book: "The service is not yet open for reservation, please stay tuned",
		is_preview_cant_book_with_schedule: "The service is not yet open for reservation, it will be open for reservation on {start}",
        please_select_service: "Please select service at top",
        please_select_service_to_start: 'Please select service to start',
        please_select_service_to_start_custom: 'Please select {custom} to start',
        code_expired_at: "Code expired at {expiredAt}",
        wrong_sms_code: 'Incorrect SMS code, please check again.',
        select_start_time: 'Select Start Time',
        done: 'Done',
        saving: 'Saving...',
        uploading: 'Uploading...',
        deleting: 'Deleting...',
        edit: 'Edit',
        add_images: 'Add Images',
        delete: 'Delete',
        delete_block: 'Delete Block',
        are_you_sure_to_delete: 'Are you sure to delete?',
        add_album_to_portfolio: 'Add Album',
        max_images_per_album_reached: 'Only {maxPhotoCount} photos can be added to an album',
        edit_album: 'Edit Album',
        new_album: 'New Album',
        set_as_cover: 'Set Cover',
        is_current_cover: 'Current Cover',
        enter_address: 'Enter address for locating',
        enter_youtube_link: 'Enter url of Youtube video',
        add_user_review: 'Add Review',
        set_customer_avatar: 'Set portrait',
        toggle_image_position: 'Toggle Image Position',
        select_image: 'Select Image',
        crop_the_image: 'Crop Image',
        photos: 'Photos',
        add_recommendation: 'Add Recommendation',
        add_option: 'Add Option',
        option_text: 'Option Text',
        set_image: 'Set Image',
        delete_question: 'Delete Question',
        open_album: 'Open',
        more_albums: 'More',
        album_image_limit: 'An album can have {maxPhotoCount} photos',
        album_image_unit: '',
        collapse_albums: 'Collapse',
        close: 'Close',
        top_banner: 'Top Banner',
        slogan_title: 'Slogan',
        slogan_title_placeholder: 'Click to enter main title',
        slogan_subtitle: 'Subtitle',
        slogan_subtitle_placeholder: 'Click to enter subtitle',
        weekday_1: 'Monday',
        weekday_2: 'Tuesday',
        weekday_3: 'Wednesday',
        weekday_4: 'Thursday',
        weekday_5: 'Friday',
        weekday_6: 'Saturday',
        weekday_7: 'Sunday',
        to: 'to',
        save: 'Save',
        confirm: 'Confirm',
        check_time: 'Check Availability',
        choose_service: 'Select Service',
        choose_member: 'Select Member',
        select_date: 'Select Date',
        select_start_date: 'Start Date',
        select_end_date: 'End Date',
        select_member: 'Select Member',
        select_service_first: 'Please select service first',
        no_member_for_service: 'No staff for the service',
        your_basic_information: 'Basic Information',
        questions_for_booking: 'Form',
        name: 'Name',
        phone: 'Phone',
        customer_phone_placeholder: 'Enter your phone for contact',
        submit: 'Submit Request',
        please_select_your_answer: 'Please select an answer',
        please_fill_your_answer: 'Please enter your answer',
        please_fill_your_name: 'Please enter your name',
        please_fill_your_company: 'Please enter your company',
        please_fill_your_phone: 'Please enter your phone',
        please_fill_your_email: 'Please enter your email',
        please_fill_your_address: 'Please enter your address',
        please_fill_your_subdomain: 'Please enter your subdomain',
        please_fill_your_line_id: 'Please enter LINE ID',
        please_fill_vat_number: 'Please enter your vat number',
        please_fill_business_entity_name: 'Please enter your business entity name',
        email: 'Email',
        please_correct_your_email: 'Please enter your email',
        cant_get_availability: 'Can\'t get availability at this moment. Please try again.',
        select_from_following_time: 'Please select date / time for service',
        no_available_time: ' This timeslot is not available for booking, please choose another time.',
        fail_to_book: 'Fail to book! Please contact admin for more information.',
        fail_to_book_service_is_disabled: 'The service is not avaiable to book now. Thanks for your inquiry.',
        fail_to_book_blocked_customer: 'Fail to book!',
        book_success: 'Booking requested. We will confirm with you later.',
        book_success_with_atm_info: 'Please pay with following info and report payment by this url <a href="{url}">{url}</a>, thanks!<br>Total:${amount}<hr>{bankInfo}',
        book_payment_atm_info: "Total:${amount}\n{bankInfo}",
        atm_info_copied: 'Info copied to clipboard',
        copy_bank_info: 'Copy Payment Info',
        confirm_submit_booking_normal: 'Are you sure to submit booking? After submission, we will receive your booking request, please don\'t make duplicate submissions, thanks.',
        confirm_submit_booking_with_online_payment: 'Are you sure to submit booking? After submission we will receive your booking request.<br><br>You will be redirect to payment page, please don\'t make duplicate submissions event if the payment is not complete. Please check your email to find the booking info to complete your payment, thanks!',
        processing: 'Processing',
        fail_to_upload: 'Fail to upload',
        fail_to_save_content_unit: 'Fail to save content',
        click_to_enter: 'Click to enter',
        click_to_enter_option_text: 'Click to enter option',
        ok: 'OK',
        click_plus_to_add_blocks_to_here: 'Click + Button to Add Content',
        now_having: 'Now having',
        only_image_supported: 'Only JPG/PNG formats are supported',
        unsupported_files_are_skipped: ' are unsuported file types. Only JPG/PNG are supported.',
        max_album_reached: 'Max album number reached',
        max_photo_reached: 'Max photo number per album reached',
        drag_to_change_order: 'Drag to change order',
        cover_photos: 'Cover Photo',
        logo_photo: 'Logo Photo',
        service_start_time_hint: 'This service starts at {startTime}',
        no_subject_entered: "Please enter subject",
        no_body_entered: "Email body is still empty",
        confirm_to_save: 'Confirm saving',
        confirm_to_cancel: 'Confirm cancelling',
        confirm_to_delete: 'Confirm deleting',
        confirm_to_restore: 'Confirm restoring ',
        add_photo: 'Choose Photo',
        please_edit_contracts_on_desktop: 'Mobile devices not supported at this moment, please use desktop/laptop to edit your contracts.',
        enter_cancel_reason: 'Reason of cancellation',
        subdomain_only_accepts_alpha_number_and_dash: 'Only alphabets, numers and dash is acceptable',
        click_to_enter_note_placeholder: 'Click to enter hints for customer to leave notes',
        deleting: 'Deleting',
        please_select_datetime_to_book: 'Select Date/Time',
        please_select_date: 'Please select date',
        duplicate: 'Duplicate',
        book: 'Book',
        fb_contact_customer: 'Facebook Messaging',
        fb_contact_customer_hint: 'If you want to be notified via Facebook Messenger, please tick the following checkbox.',
        add_block: 'Add Content',
        select_block_to_add: 'Choose type of content',
        file_should_smaller_than_25_mb: 'Max file size is 25MB ({fileName} is {size} MB)',
        files_should_smaller_than_25_mb: 'Max file size is 25MB. Following file(s) is skipped {fileNames}.',
        add_question: 'New Item',
        click_plus_to_add_question_to_here: 'Click + to add new item',
        select_question_to_add: 'Select item type to add',
        n_more_bookings: '+{n} More',
        check_question_password_title: 'Please enter the password',
        check_question_password_label: 'Password',
        check_question_password_button: 'Enter Shop',
        check_question_password_warning: 'Please enter the password',
        check_question_password_fail: 'Incorrect password',
        check_question_password_fail: 'Incorrect password, go back to home page',
        no_customer_found: 'Sorry, can\'t find your customer record',
        no_track_order_input: 'Please fill in the related information',
        landing_page_is_preparing: 'Website is preparing',
        preparation_hint: 'Website in preparation, only administrator can see the page.',
        please_fill_line_id_or_line_url: 'Please fill LINE id or LINE url',
        select_custom: 'Select {custom}',
        row: 'Row',
        column: 'Column',
        add_row: 'Add row',
        add_column: 'Add column',
        click_to_enter_row_title: 'Click to enter row title',
        click_to_enter_column_title: 'Click to enter column title',
        cart_items_all_not_available_in_this_month: 'All items in cart are not available in this month bookable time, please check again.',
        reorder_hint: 'Please drag the icon to adjust the order.',
        sum_max_size_exceeded: 'Maximum upload images size {max}MB exceeded',
        upload_image_failed: 'Fail to upload image, please try again',
        please_verify_customer_sms: 'Please verify customer\'s phone number first',
    },
    general: {
        no_thanks: 'No thanks',
        share: 'Share',
        item_link_copied: 'Item link copied to your clipboard',
        copy_failed: 'Copy failed',
        count: 'Count',
        apply: 'Apply',
        per_day: 'Per day',
        per_week: 'Per week',
        per_month: 'Per month',
        yesterday: 'Yesterday',
        today: 'Today',
        tomorrow: 'Tomorrow',
        last_week: 'Last Week',
        this_week: 'This Week',
        next_week: 'Next Week',
        last_month: 'Last Month',
        this_month: 'This Month',
        next_month: 'Next Month',
        empty_description: 'None',
        profile: 'Profile',
        bookings: 'Bookings',
        setting: 'Setting',
        logout: 'Log out',
        login: 'Log in',
        head_to: 'Go',
        required: 'Required',
        optional: 'Optional',
		total_amount: "",
		ge: "x{count}",
		unlimited: "Unlimited",
		manage: 'Manage',
        day_1: '1st',
        day_2: '2nd',
        day_3: '3rd',
        day_n: '{n}th',
        month: "Month",
        day: "Day",
        until: 'until',
        modify: 'Modify',
        edit: "Edit",
        select: 'Select',
        select_all: 'Select All',
        cancel_select: 'Cancel Selection',
        saving: 'Saving...',
        deleting: 'Deleting',
        finish: 'Finish',
        oops: 'Oops',
        close: 'Close',
        created_at: 'Created at',
        done: 'Done',
        actions: 'Actions',
        cancel: 'Cancel',
        leave: 'Leave',
        extra_hours: 'Extra Hours',
        service_extra_hours: 'Extra Hours',
        create_new: 'Create',
        new: 'New',
        save: 'Save',
        update: 'Update',
        delete: 'Delete',
        expand: 'Expand',
        collapse: 'Collapse',
        deleted_at: 'Deleted at',
        confirm: 'Confirm',
        deleted: 'Deleted',
        am: 'AM',
        pm: 'PM',
        warning: 'Warning',
        to: 'to',
        fail: 'Fail',
        success: 'Success',
        input_is_required: 'Please enter content',
        please_select: 'Please select',
        align_left: 'To Left',
        align_right: 'To Right',
        align_middle: 'Center',
        no_title: 'No title',
        notice: 'Notice',
        go_back: 'Back',
        create: 'Create',
        more: 'more',
        datetime_to_booking: 'Time',
        booking_end_datetime: 'End Time',
        hint: "Hint",
        check_customer_link: "Order Link",
        track_order: 'Track Order',
        track_order_again: 'Track Order Again',
        twd: 'TWD $',
        clear: 'Clear',
        sort: 'Reorder',
        save_order: 'Save Order',
        times: 'time(s)',
        points: 'point(s)',
        no_data: 'No Data',
        archive: 'Archive',
        unarchive: 'Unarchive',
        search: 'Search',
        unknown: 'Unknown',
        male: 'Male',
        female: 'Female',
        other: 'Unspecified or other gender identity',
        under20: 'Under 20 years old',
        '21-25': '21 - 25 years old',
        '26-30': '26 - 30 years old',
        '31-35': '31 - 35 years old',
        '36-40': '36 - 40 years old',
        '41-45': '41 - 45 years old',
        '46-50': '46 - 50 years old',
        '51-55': '51 - 55 years old',
        '56-60': '56 - 60 years old',
        over60: 'Over 60 years old',
        start_date: "Start date",
        end_date: "End date",
        service: 'Service',
        member: 'Member',
        buyable: 'Buyable',
        preselected_buyable: 'Preselcted Buyable',
        datetime: 'Datetime',
        color_picker: 'Color Picker',
    },
    provider: {
        service_leave: 'Service Pause',
        who_is_taking_leaves: 'Who is taking leaves?',
        remove_this_service_leave: 'Customers will be able to book this time after removing this service timeoff.',
        remove_this_member_leave: 'Customers will be able to book this time after removing this leave.',
        remove_this_member_extra_hours: 'Customers will be unable to book this time after removing this extra hours.',
        remove_this_service_extra_hours: 'Customers will be unable to book this time after removing this extra hours.',
        cancel_leave: 'Remove',
        cancel_leave_title: 'Are you sure to remove this service timeoff?',
        cancel_extra_hours: 'Remove',
        cancel_service_extra_hours: 'Remove',
        cancel_extra_hours_title: 'Are you sure to remove the extra hours of this member?',
        cancel_service_extra_hours_title: 'Are you sure to remove the extra hours of this service?',
        cancel_member_leave_title: 'Are you sure to remove this leave?',
        leave_overlapped: 'New leaves overlapped with previous arragned ones, please adjust your leave date.',
        failed_to_add_leave: 'Fail to add leave. ',
        booking_status: 'Status',
        service: 'Service',
        member_user: 'Staff',
        service_datetime: 'Service Time',
        service_end_datetime: 'Service End Time',
        customer: 'Customer',
        customer_phone: 'Customer Phone',
        booking_status_unapproved: 'Pending',
        booking_status_approved: 'Approved',
        booking_status_rejected: 'Rejected',
        booking_status_cancelled: 'Cancelled',
        booking_status_customer_cancelled: 'Customer Cancelled',
        take_leave: 'Take Leave',
        single_day_off: 'Single Day-off',
        multiple_day_off: 'Multiple Day-offs',
        day_off_mode_hint: 'Which type of leaves are you taking?',
        leave_date: 'Leave Date',
        leave_start_date: 'Start Date',
        leave_end_date: 'End Date',
        availabilities: 'Availabilities',
        files_uploading_sure_to_exit: 'There are files being uploading, are you sure to exit?',
        booking_id: 'ID',
        should_update_all_member_working_time: 'Please note that availability of members are determined by their working time not business working hour set here. <br><br> Would you like to update all members working time also?',
        update_all: 'Update All',
        dont_update: 'Keep Member Working Time',
    },
    informationBlock: {
        contentRenderType: {
            'CONTENT_RENDER_TYPE_TEXT': 'Text',
            'CONTENT_RENDER_TYPE_IMAGE': 'Image',
            'CONTENT_RENDER_TYPE_TEXT_AND_IMAGE': 'Image with text',
            'CONTENT_RENDER_TYPE_MULTIPLE_TEXT_AND_IMAGES': 'Multiple images with text',
            'CONTENT_RENDER_TYPE_ADDRESS': 'Address',
            'CONTENT_RENDER_TYPE_PORTFOLIO': 'Portfolio',
            'CONTENT_RENDER_TYPE_USER_REVIEW': 'User Review',
            'CONTENT_RENDER_TYPE_PROVIDER_RECOMMENDATION': 'Recommendation',
            'CONTENT_RENDER_TYPE_SERVICES': 'Services',
            'CONTENT_RENDER_TYPE_MEMBERS': 'Members',
            'CONTENT_RENDER_TYPE_IG': 'Instagram',
            'CONTENT_RENDER_TYPE_BOOKABLES': 'Bookable Items',
            'CONTENT_RENDER_TYPE_YOUTUBE': 'Youtube Video',
        }
    },
    question: {
        answerType: {
            'ANSWER_TYPE_SHORT_ANSWER': 'Short Text',
            'ANSWER_TYPE_PARAGRAPH': 'Long Text',
            'ANSWER_TYPE_SINGLE_CHOICE': 'Single Choice',
            'ANSWER_TYPE_MULTIPLE_CHOICE': 'Multiple Choices',
            'ANSWER_TYPE_MULTIPLE_CHOICE_WITH_NOTE': 'Multiple Choices With Note',
            'ANSWER_TYPE_INFO': 'Info',
            'ANSWER_TYPE_FILE_UPLOAD': 'File Upload',
            'ANSWER_TYPE_DATE': 'Date',
            'ANSWER_TYPE_SHOPPING': 'Shopping',
            'ANSWER_TYPE_LINEAR_SCALE': 'Linear Scale',
            'ANSWER_TYPE_SECTION': 'Section',
            'ANSWER_TYPE_ADDRESS': 'Address',
            'ANSWER_TYPE_YOUTUBE': 'Youtube',
            'ANSWER_TYPE_SINGLE_MATRIX': 'Single Matrix',
            'ANSWER_TYPE_MULTIPLE_MATRIX': 'Multiple Matrix',
        },
        required: 'Required',
        title_placeholder: 'Enter question',
        enter_question_description: 'Enter more details of this question',
        no_options_for_this_question: 'No options set for this question, it won\'t be shown for customer.',
        insert_image: 'Set Question Image',
        info_title_placeholder: 'Info Block Title(Can be blank)',
        section_title_placeholder: 'Section Title (Can be blank)',
        address_title_placeholder: 'Address Block Title (Can be blank)',
        youtube_title_placeholder: 'Youtube Block Title (Can be blank)',
        set_image: 'Set Image',
        info_text_placeholder: 'More explanation',
        note: 'Note'
    },
    email: {
        compose: 'Compose',
        subject: 'Subject',
        subject_hint: 'Mail subject',
        apply_template: 'Apply Templates',
        template_saved: 'Template saved',
        to: 'To',
        body: 'body',
        send: 'Send',
        choose_from_template: 'Select template',
        compose_template: 'Compose Template',
        template_title: 'Template Title',
        no_templates_yet: 'No templates yet.',
        fail_to_send_mail: 'Fail to send',
        fail_to_send_mails_for_bookings: 'Fail to send email for following bookings:\n {bookings}',
        mail_sent: 'Mail sent',
        not_sent_successfully: 'Failed to send',
        fail_to_update_email_template: 'Fail to update template',
        fail_to_create_email_template: 'Fail to create template',
        save_edited_template: 'Save',
        save_as_template: 'Save as template',
        template_delete: 'Delete template {templateName}?',
        type: {
            'customer-booking-request': 'Booking requested notification',
            'customer-booking-approved': 'Booking approved notification',
            'customer-booking-rejected': 'Booking rejected notification',
            'customer-booking-cancelled': 'Booking cancelled notification',
            'request-sign-contract': 'Contract signing request',
            'customer-contract-signed': 'Contract signed notification',
            'customer-booking-cancelled-by-customer': 'Customer cancelled booking notification',
            'customer-booking-reminder': 'Customer booking reminder',
            'customer-custom-mail': 'Manual email sent',
            'customer-invite-file-vault': 'File Vault Invitation'
        }
    },
    services: {
        form_created_and_linked_to_service_go_edit: 'Form created and linked to service, go edit form?',
        accept_booking_until_day_time: 'Accept booking until {end} of the day',
        can_custom_duration: 'Allow Custom Duration',
        minimum_custom_duration: 'Min Duration',
        maximum_custom_duration: 'Max Duration',
        fixed_time_for_end: 'Fixed End  Time',
        hide_duration: 'Hide duration',
        hide_limited_periods: 'Hide limited periods',
        payment_gateways: 'Accept Payment Methods',
        payment_gateways_hint: 'Select payment methods available for this service',
        payment_manual: 'Pay at counter',
        payment_atm: 'Bank Transfer',
        payment_ecpay: 'ECPay',
        payment_wait: 'Wait for payment notification',
        payment_linepay: 'LINE Pay',
        payment_tappay: 'TapPay',
        auto_approve_with_down_payment: 'Approve booking automatically when down payment received',
        auto_request_down_payment_hint: 'After the customer makes a booking, automatically sends an deposit request. Note: A deposit can only be automatically requested with self-transfer or online payment integration selected.',
        online_payment_methods_required_to_enable_auto_down_payment: 'At least one online payment method has to be check to enable auto down payment',
        auto_request_down_payment: 'Request Down Payment Automatically',
        down_payment_amount: 'Down Payment Amount',
		auto_request_payment: 'Auto Request Payment',
        time_split: 'Interval between sessions (minutes)',
        auto_approve: 'Approve Request Automatically',
        auto_approve_hint: 'Automatically approve booking request when member is avaialble or service allows multiple bookings at a same timeslot.<br><span class="text-warning">If there\'s shopping question in the form used, please set auto approving in form setting page.</span>',
        deleted_service: 'Obsolete Service',
        add_new_service: 'New service',
        select_service_icon: 'Please selct service icon',
        title: 'Title',
        title_placeholder: 'Enter service title',
        description: 'Description',
        description_placeholder: 'Enter description about the service',
        duration: 'Duration',
        price: 'Pricing',
        price_up: 'Up',
        no_price: 'Contact for price',
        fixed_price: 'Fixed',
        range_price: 'Range ',
        min_price: 'Minimum Price',
        place: 'Place',
        place_placeholder: 'Enter place for the service or meeting point',
        members: 'Members',
        duration_format: '{hours} hours {minutes} minutes',
        duration_format_hour_only: '{hours} hours',
        duration_format_minute_only: '{hours} minutes',
        start_datetime_limited: 'Limited time offer',
        start_datetime_limited_hint: 'Customer can only book service within limited time range.',
        limited_period: "Period limited {start} to {end}",
        start_time_format: '{amPm} {hour}:{minute}',
        hour: 'hour',
        minute: 'minute',
        hours: 'hours',
        minutes: 'minutes',
        hour_short: 'hour',
        minute_short: 'minute',
        am: 'AM',
        pm: 'PM',
        editor: {
            create: 'Create service',
            edit: 'Edit service'
        },
        fixed_start_time: 'Fixed start time',
        fixed_start_time_at: 'Start at {start}',
        fixed_start_time_hint: 'If this is set, customer can only select date of service. This is for services like "Makeup for Evening Banquet", "Afternoon photo-shooting"',
        use_form: 'Use form',
        preview_form: 'Preview form',
        allow_multiple_orders: 'Allow multiple orders',
        allow_multiple_orders_hint: 'When enabled, this service will be allowed to overlap with other services also allow multiple orders.',
        validation: {
            title_empty: 'Please enter title',
            duration_empty: 'Please set duration',
            no_members_selected: 'Please select staff',
            start_time_not_set: 'Please select start time',
            price_not_set: 'Please set pricing'
        },
        service_saved: 'Service saved',
        create: 'Add Service',
        delete_service: 'Delete',
        confirm_delete_service: 'Are you sure to delete this service?',
        confirm_delete_service_text: 'Customers will not be able to book this service. You can still see past booking for this service.',
        disable_service: 'Hide Service',
        service_disabled: 'Not Open for Booking',
        schedule_auto_disable: 'Schedule to disable',
        schedule_auto_enable: 'Schedule to enable',
        service_accepting_booking: 'Accepting Booking',
        accept_booking_from_until: 'Accept booking period',
        accept_booking_unit_day: 'Day(s)',
        accept_booking_unit_hour: 'Hour(s)',
        accept_booking_unit_month: 'Month(s)',
        accept_booking_unit_year: 'Year(s)',
        accept_booking_unit_minute: 'Minute(s)',
        accept_booking_unit_night: 'Night(s)',
        start_accepting_booking: 'before',
        stop_accepting_booking: 'before',
        stop_accepting_booking_earlier: 'before',
        stop_accepting_booking_earlier_with_time: 'before at',
        disable_service: 'Suspend',
        enable_service: 'Continue Service',
        service_is_disabled: 'Service is temporarily suspended',
        service_is_enabled: 'Service is launched again.',
        check_accept_booking_from: 'Set Start Accepting Booking From',
        check_accept_booking_until: 'Set Accepting Booking Until',
        at_least_earlier_than: '',
        at_least_later_than: '',
        cancellation_policy: 'Cancellation Policy',
        cancellation_policy_anytime: 'Cancel Anytime Before Service',
        cancellation_policy_anytime_before_end: 'Cancel Anytime Before Service Ends',
        cancellation_policy_no: 'No Cancellation on website',
        cancellation_policy_before_n: 'Accept cancellation on website ahead of service',
        cancellation_policy_hint: 'Customers are allowed to cancel unapproved bookings. For approved bookings, following selected rule will be applied.',
        stop_accept_cancellation: 'before accept cancellation',
        cancellation_text: 'Message to customer when it\'s not cancellable. If left blank, "This booking is not cancellable, please contact us. Thanks." will be shown by default.`',
        save_order: 'Save Order',
        sort: 'Reorder',
        order_saved: 'Service order saved',
        max_amount_per_day_per_member: 'Booking Cap Per Member Per Day',
        max_amount_per_day_per_customer: 'Booking Cap Per Customer Per Day for Each Member',
        orders: 'bookings',
        notify_customer_before_n_hour: 'Time to Remind Customer',
        hours_before_service: 'Notify customer {0} hour(s) before service',
        need_premium_to_custom_reminder_time: 'Upgrade to "Swan" plan to customize time for reminder.',
        custom_reminder_time_membership_hint: 'With "Swan" membership, you can customize time to remind your customers',
        limited_start_datetime_expired: 'Expired',
        enable_sms_verification: 'Enable Phone Number Verification',
        enable_sms_verification_hint: 'When enabled, customers are required to verify their phone number by entering code sent to their phone via SMS.<br> <b>**If you have not enough SMS credits, customers will not be able to book!**</b> Please ensure you have sufficient booking credits deposited.',
        private_service: 'Private Service',
        enter_private_password: 'Enter the password',
        private_password_label: 'Password',
        private_copy_content: 'Please click the following link to go to the private shop page.',
        private_warning_text: 'The password is required',
        copy_private_link: 'Copy',
        private_link_copied: 'Copied',
        private_link_error: 'Cannot Copy',
        private_service_hint: 'Customer will be asked to enter password to book. If you want to apply for this feature, please contact Ding directly.',
        private_service_hint_enabled: 'Customer will be asked to enter password to book. ',
        archive_service: 'Archive',
        archived_service: 'Archived',
        already_archived_service: 'Service {name} is archived',
        service_is_unarchived: 'Service {name} is unarchived',
        service_is_archived: '{name} is archived and set as suspended.',
        service_is_archived_disabled_already: '{name} is archived',
        service_is_unarchived: '{name} is unarchived. Please set unsuspended if needed manually.',
        is_preview: 'Allow preview booking form when service is disabled',
        please_enter_service_price: 'Please enter service price',
        please_enter_down_payment_amount: 'Please enter down payment amount (amount should larger than 0)',
        points_deductable: 'Points Deductable',
        hide_start_time: 'Hide fixed start time',
    },
    theme: {
        landing_theme: 'Theme',
        background_color: 'Background Color',
        tint_color: 'Tint Color'
    },
    booking: {
        book_again: 'Book Again',
        issues_found: 'Please check following issues before confirming booking.<br> {bookingInfo}',
        print: 'Print',
        display_id: 'ID',
        created_by: 'Created by {creatorName}',
        customer: {
            name: 'Name',
            phone: 'Phone',
			phone_calling_code: 'Country Code',
            note: 'Note',
            no_note: 'No notes yet',
            email: 'Email'
        },
        mail: {
            fail_to_sent: 'Fail to sent',
            sent: 'Sent'
        },
        note: 'Internal Note',
        note_to_customer: 'Note for customer',
        note_from_provider: 'Note',
        email_status_report: 'Email status report',
        created_at: 'Booked at',
        information: 'Information',
        datetime: 'Time',
        customer_information: 'Customer Information',
        service_information: 'Booking',
        answers: 'Form',
        accept: 'Accept',
        open_detail: 'View',
        reject: 'Reject',
        brief: 'Will book service {2} by {1} at {0}',
        open_email_module: 'Mailing',
        reason_of_rejection: 'Reject Reason',
        reason_of_rejection_placeholder: 'Please enter reason of rejection. Customers will see the reason in notification mails.',
        reason_of_rejection_placeholder_with_presets_bookings: 'Other bookings created by booking pass will also be accepted at once.<br><br>Please enter reason of rejection. Customers will see the reason in notification mails.',
        are_you_sure_to_accept_order: 'Are you sure to accept this booking?',
        are_you_sure_to_accept_order_with_presets: 'Other bookings created by booking pass will also be accepted at once.<br><br>Are you sure to accept this booking?',
        are_you_sure_to_cancel_this_booking: 'Are you sure to cancel this booking? You can enter reason of cancellation, customer will see it in notification.',
        are_you_sure_to_cancel_this_booking_with_presets: 'Other bookings created by booking pass will also be cancelled.<br><br>Are you sure to cancel this booking? You can enter reason of cancellation, customer will see it in notification.',
        no_approved_bookings: 'No ongoing bookings',
        no_unapproved_bookings: 'No new bookings',
        no_customer_cancelled_bookings: 'No bookings cancelled by customer.',
        no_other_bookings: 'No expired or rejected bookings',
        has_past_no_reply: 'Expired',
        warn_overlap_booking: 'Already bookings at the same time',
        booked_at: 'Booked at {bookedAt}',
        edit: 'Edit',
        save: 'Save',
        service_duration: 'Duration',
        unknow_service_time: 'Unknown',
        service_or_member_missing: 'Select service/staff first',
        overlapped_booking_confirm_title: 'Sure to keep the time?',
        overlapped_booking_accept_confirm: 'will overlap with following booking. Are you sure to keep this time? <br><br> {bookingInfo}',
        overlapped_booking_confirm: 'will overlap with folloing booking. Are you sure to keep this time? <br><br> {bookingInfo}',
        newly_saved_booking: 'ID {bookingDisplayId} saved',
        confirm_creating_booking: 'Sure to save?',
        confirm_saving_booking: 'Sure to save?',
        enter_booking_id_to_search: 'Search by booking ID, customer name, and phone number',
        enter_booking_id_to_search_mobile: 'Search',
        member_doesnt_provider_this_service: 'This staff doesn\'t provide this service',
        member_not_working_at_selected_datetime: 'This staff doesn\'t work at the selected date/time',
        member_leave_or_booked_at_selected_datetime: 'Thie staff has booking or has taken leaves at the selected date/time',
        invalid_booking_content_explanaing: 'This Booking is not conformed to your normal staff/service settings.<br> Please make sure this is what you want before saving.',
        cancel_booking: 'Cancel Booking',
        cancelled_at: "Cancelled at {cancelledAt}",
        customer_cancelled_at: "Customer Cancelled at {cancelledAt}",
        rejected_at: "Rejected at {rejectedAt}",
        new_question: 'New Question',
        end_datetime: 'End Datetime',
        add_booking: 'Add Booking',
        edit_order: 'Edit Order'
    },
    information: {
        bio_link_integration: 'Biolinks',
        transfer_bank_info: 'Bank Transfer Info',
        transfer_bank_info_placeholder: 'Information of your bank account to accept bank transferring. Including: Bank Name, Bank Branch Name, Your Account and Account Title',
        receiver: 'Receiver',
        vat_number: 'VAT Number',
        business_entity_name: 'Business Entity',
        show_business_entity_info: 'Show Vat Number and Business Entity Info in main page',
        print_scale: 'Print Scale',
        print_scale_s: 'Small',
        print_scale_m: 'Normal',
        print_scale_l: 'Large',
        old_landing_version: 'Tradition Version',
        landing_version_preview_forms: 'New Form Preview Version',
        landing_version: 'Landing Version',
        preview_landing_v2: 'Checkout Form Preview Version',
        name: 'Business Name',
        phone: 'Phone',
        email: 'Email',
        company_address: 'Company Address',
        contact_address: 'Contact address',
        address: 'Address',
        subdomain: 'Subdomain',
        line_id: 'LINE ID / LINE Link',
        timezone: 'timezone',
        confirm: 'confirm',
        save: 'save',
        name_placeholder: 'Enter name of your business',
        custom_domain: 'Custom Domain',
        email_preference: 'Email Preference',
        email_preference_booking_status_change: 'Subcribe Email Notifications on New Booking/Booking Status Udpate/Payment Status Update',
        google_site_verification_code: 'Google Site Verification Code',
        currency: 'Currency',
        facebook_account: 'Fan Page Username',
        twitter_account: 'X Account',
        instagram_account: 'Instagram Account',
        seo_title: '[SEO] Website Title',
        seo_description: '[SEO] Website description',
        seo_title_placeholder: 'Please enter content of website title tag. Default will be your business name',
        seo_description_placeholder: 'Please enter content of website description meta tag. This will help SEO ranking.',
        seo_title_hint: 'Search engines take website\'s title into account when ranking websites. Having your company/studio\'s name and your services briefly here is recommended.',
        seo_description_hint: 'Search engines show your website description in the search result page. Well written and succinct description attracts more customers.',
        ask_order_member_first: 'Choose staff first',
        ask_order_service_first: 'Choose service first',
        ask_order: 'Landing Page Staff/Service Selection Order',
        login_module: 'Customer Login',
        login_module_hint: 'Allow customer to login via phone number / facebook / LINE',
        login_module_explanation: 'To enable this feature, <b class="text-danger">must add SMS credits</b> to carry out customer phone number verification<br>To enable Facebook login, please click <a href="/b/integration">integrate Facebook fan page</a> first and enable <a href="/b/notification_setting?current_notification_type=facebook">Facebook Messenger Notification</a><br>To enable LINE login, please integrate the LINE Login service first',
        head_html: 'Html Head',
        head_html_placeholder: 'Enter HTML tag to be set into your landing page. Can be used to set up Google Merchant verification or Google Analytics.',
        landing_is_preparing: 'Set website as in preparation',
        ga_tracking_id: 'GA Tracking ID',
        ga_tracking_id_placeholder: 'Enter Google Analytics Tracking ID',
        show_line_customer_chat: 'show in landing page',
        enable_login_without_sms_verification: 'Enable Login without SMS Verification',
    },
    form: {
        form: 'Form',
        default_title: 'Default Form',
        create_new_form_option: 'Create new form',
        or_create_new_form_option: '...or create a new form',
        show_archived_form: 'Show archived form',
        duplicate_form: 'Duplicate Form',
        create_new_form: 'Create Form',
        create_new_form_hint: 'You can have different forms for services.',
        create_new_form_placeholder: 'Form Title (Only for identifying, not visible to customer)',
        update_form: 'Update Form',
        update_form_placeholder: 'Please enter new form name (Only for identifying, not visible to customer)',
        please_select_accepting_file_types: 'Select accepting file type',
        file_type_image: 'Image（JPG/PNG）',
        file_type_pdf: 'PDF Document',
        file_type: 'File Type',
        max_file_count: 'Max File Uploaded',
        file_unit: 'file|files',
        select_file: 'Select File',
        click_to_enter_file_caption: 'Enter caption',
        too_many_files: 'Max file amount exceeded',
        please_select_file_to_upload: 'Please upload file(s)',
        sure_to_delete_form: 'Are you sure to delete this form? Services bound to this form will no longer ask customers to fill out form.',
        sure_to_duplicate_form: 'Create another form based on this one? Modification afterwards won\'t affect each other.',
        duplicate_form_placeholder: 'Enter name for new form',
        form_is_archived: "Form {name} is archived",
        form_is_unarchived: "Form {name} is unarchived",
        archived_forms: "Archived forms",
        section: "Section {count}",
    },
    bookingTable: {
        show_only_today_bookings: 'Today\'s Only',
        booking_pass_used: 'Booking Pass Used',
        please_enter_contracted_customer_id: "Please enter your contraced customer id with TCat",
        logistic_method: "Logistic Method",
        export_for_tcat: "TCAT Export",
        export_for_ezprint: "TCAT Export(EZPRINT)",
        export_all: 'Export All',
        print_all_limit_exceeds: 'Exceeds max bookings count {max} to print at once, please reduce range and try again.',
        fetching_bookings: 'Now fetching bookings',
        print_all: 'Print All',
        any_status: "All Status",
        payment_paid: "Paid",
        payment_has_pending: "Pending",
        payment_has_expired: "Expired",
        payment_has_failed: "Failed",
        payment_has_cancelled: "Cancelled",
        logistic: "Delivery",
        payment_condition: "Payment Status",
        created_manually: "Manually Created",
        auto_approved: 'Auto-Approved',
        sms_verified: 'Phone Verified',
        sms_not_verified: 'Phone Not Verified',
        notification_failure: 'Failed',
        notification_sending: 'Sending',
        notification_success: 'Success',
        email_subject: 'Subject',
        file_vault_is_enabled: 'Enabled',
        unapproved_booking: 'Pending',
        approved_booking: 'Ongoing',
        other_booking: 'Expired/Rejected',
        paging_information_entry: 'Total {total} bookings',
        paging_information_page: ' {current} / {totalPage}',
        create_new_booking: 'New Booking',
        no_note_yet: 'No notes yet',
        note_content: 'Note',
        check: 'Check',
        customer_notification: 'Customer Notification',
        notification_log: 'Notification Log',
        sync: 'Sync',
        no_notification_log: 'No notification logs.',
        filter: 'Filter',
        already_filtered: 'Filtere ON',
        filter_condition: 'Filters',
        clear_all_conditions: 'Clear all filters',
        clear_condition: 'Clear',
        service_interval: 'Date range',
        start_hours: 'Start hour',
        end_hours: 'End hour',
        service_content: 'Services',
        booking_passes: 'Booking Passes',
        service_member: 'Staff',
        syncing_booking: 'Pushing booking to Google Calendar...',
        syncing_booking_done: 'Pushed',
        batch_accept_bookings: 'Accept Bookings',
        batch_reject_bookings: 'Reject Bookings',
        accept_ok: 'Accepted',
        reject_ok: 'Rejected',
        cancel_booking: 'Delete',
        cancel_ok: 'Booking cancelled',
        loading_bookings: 'Loading bookings',
        file_vault: 'File Vault',
        customer_cancelled_bookings: 'Customer Cancellation',
        new_customer_cancelled: 'New',
		sms_status_FAILED_SYSTEM: "System Error",
		sms_status_FAILED_SMS_PROVIDER: "SMS Service Provider Error",
		sms_status_FAILED_INSUFFICIENT_CREDIT: "Insufficient Credit",
		notification_type_sms: "SMS",
        notification_type_email: "Email",
        notification_type_line: "LINE",
        send_sms: 'Send SMS',
        full_message: "Message",
        in_booking_group: "Booking Group",
        export: "Export",
        payments: "Payments",
        send_mail_to_filtered_bookings: "Send mail for {n} filtered bookings",
        send_sms_to_filtered_bookings: "Send SMS for {n} filtered bookings",
        selected_member_hint: "Services provided by {names}",
        line_status_error_400: "Failed to send",
        line_status_error_401: "Failed to send",
        line_status_error_403: "Failed to send",
        line_status_error_404: "Failed to send",
        line_status_error_409: "Failed to send",
        line_status_error_410: "Failed to send",
        line_status_error_413: "Failed to send",
        line_status_error_415: "Failed to send",
        line_status_error_429: "Failed to send",
        line_status_error_500: "Failed to send",
    },
    grade: {
        grade: 'Grade',
        level: 'level',
        create: 'Create new grade',
        please_input_grade_level: 'Please enter grade level'
    },
    grade_capability: {
        enabled: 'Enabled',
        max: 'Max'
    },
    capability: {
        item: 'Item',
        capability: 'capability',
        title: 'title',
        type: 'type',
        onoff: 'On/Off',
        maxcap: 'maxcap',
        default: 'default',
        create: 'Create',
        please_input_capability_title: 'Enter capability id (alphabets)',
        please_input_capability_display_label: 'Enter display label',
        please_pick_capability_type: 'Please choose type',
        please_input_capability_default: 'Please enter default value',
        profolio_count: 'Number of portforlio blocks',
        photo_count_per_album: 'Photo count per album',
        photo_compression: 'Photo compression level (0 ~ 1)',
        email_module: 'Email module enabled',
        google_calendar: 'Google Calendar Integration',
        team_member_count: 'Team Member Count',
        member_points: 'Member Points',
        email_price_per_exceeding: 'Email Price Per Exceeding',
        coupon_available_per_year: 'Coupon Available Per Year' ,
        promocode_available_per_year: 'Promocode Available Per Year' 
    },
    errors: {
        error_occured: 'Error Occured',
        unknown: 'Unknown error',
        service: {
            end_date_must_not_be_before_start_date: 'End date must not before start date',
            no_working_day_ok_for_such_service_time_setting: 'No member is able to provide this service according to their working hours setting.',
            update_fail: 'Fail to update service'
        },
        api: {
            forbidden: {
                no_gcalendar_integration_yet: 'Cannot push booking to Google Calendar because staff doesn\'t have Google Calendar integrated',
                cant_delete_last_admin: 'Cannot delete last admin.'
            }
        },
        onboard: {
            subdomain_not_available: 'Subdomain not available',
            please_enter_service_title: 'Please enter service title',
            please_enter_service_duration: 'Please enter service duration',
            subdomain_allows_alphadigits_only: 'Only english small case letters and digits are allowed for subdomain!'
        }
    },
    members: {
        create: 'Add Staff',
        detail: 'Staff Detail',
        name: 'Name',
        email: 'Email',
        role: 'Role',
        phone: 'Phone',
        short_id: 'Short ID',
        color: 'Color',
        name_placeholder: 'Enter name of staff',
        email_placeholder: 'Enter email of staff',
        phone_placeholder: 'Enter phone of staff',
        short_id_placeholder: 'Enter 2 digit alphanumerics',
        role_placeholder: 'Role',
        working_times: 'Working Hour',
        apply_provider_working_time: 'Apply business working hour',
        member_saved: 'Staff saved',
        confirm_delete_member: 'Are you sure to remove this staff?',
        delete_member: 'Delete staff',
        deleted: 'Deleted',
        restore_member: 'Restore staff',
        confirm_restore_member: 'Are you sure to restore this staff?',
        add_member: 'Add staff',
        placeholder_name: 'Staff name',
        placeholder_content: 'Staff ',
        validation: {
            name_empty: 'Please enter name of staff',
            email_empty: 'Please enter email of staff',
            short_id_empty: 'Please enter short ID of staff',
            role_not_selected: 'Please specify role for staff'
        },
        is_internal: "Set as Internal Member",
        is_internal_hint: "Internal Member won't be listed for customer to choose directly.",
        verification_mail_is_sent_to_new_member_email: 'An invitation mail has been sent to new member\'s email address {email}. Please ask new member to open the invitation mail and log in system.'
    },
    provider_role: {
        admin: 'Administrator',
        member: 'Normal Staff'
    },
    onboard: {
        previous: 'Previous',
        next: 'Next',
        welcome: {
            title: 'Welcome',
            text: 'Ready to customize your booking system',
            ready: 'I am ready!'
        },
        subdomain: {
            title: 'Subdomain',
            text: 'You can choose a unique subdomain for your booking website',
            hint: 'alphanumerics'
        },
        workingTime: {
            title: 'Working Hours',
            text: 'You can set up working hours from <span class="highlighted">Information</span> panel at the left sidebar later.<br> We have set up deafult working hours as Monday-Friday 08:00 ~ 17:00 for you.'
        },
        services: {
            title: 'Services',
            text: 'You can set up more services from <span class="highlighted">Services</span> panel at the left sidebar.<br> Just create a service now!'
        },
        members: {
            title: 'Staff',
            text: 'You can set up more staff from <a class="highlighted" href="{link}" target="_blank">Staff</a> panel at the left sidebar.<br> We have set up one for you already.'
        },
        finish: {
            title: 'You are all set',
            text: 'A <span class="highlighted">booking system for your business</span> is now ready to accept bookings!<br>There are granular seettings for you to set up but before that let\'s enable your customer to find your booking website',
            start: 'Expose Booking System to Customers'
        }
    },
    plan: {
        upgrade_now: 'Upgrade Now',
        offer_management: 'Discount Management',
        customer_login: 'Customer Log In',
        shopping_bag_module: 'Shopping Module',
        by_using_our_service_you_are_accepting_our_terms_and_privacy_policy: 'I agree to Ding system\'s <a target="_blank" href="https://dingup.cc/terms">terms</a> and <a target="_blank" href="https://dingup.cc/privacy">privacy policy</a>.',
        invoice_email: "Email",
        invoice_donation_code: "Invoice Donation Code",
        default_88888_hint: "88888 is donation code of Childhood Cancer Foundation of R.O.C.",
        basic: 'Hummingbird',
        standard: 'Puffin',
        premium: 'Swan',
        upgrade_needed: 'Plan upgrade Needed',
        upgrade: 'Upgrade Now',
        upgrade_reason_team_full: 'For your current plan, you can have no more than {teamMemberCount} team members. Please upgrade your plan to have more members.',
        month: 'month',
        annually_pay_savings: 'Pay annually to save {currency} {saving}',
        photo_quality: 'Photo Quality',
        team_member_cap: 'Max Team member Count',
        portfolio_number: 'Portfolio Content',
        portfolio_number_content: '{album} albums x {photo_per_album} photos',
        compression: 'Photo compression',
        auto_notification: 'Email Notifications',
        auto_notification_with_manual: 'Email Notifications<br>(Can send email manually)',
        reservation_form: 'Forms',
        medium_photo_quality: '1080P/Normal Compression',
        high_photo_quality: '4K/Light Compression',
        unlimited: "Unlimited",
        email_management: "Email Management",
        google_calendar_integration: "Google Calendar Integration",
        team_calendar_management: "Team Calendar Management",
        email_management_tips: "Enable email management system to save email templates and send your customized email to customer in a breeze.",
        upgrade_now: "Upgrade Now",
        please_choose_duration: "Choose subscription duration",
        becoming_membership_of: "Join {planTitle} membership",
        season: '3 Months',
        'half-year': '6 Months',
        year: '12 Months',
        months: 'Months',
        ready_to_subscribe: 'Ready to subscribe',
        subscription_item: 'Subscription Item',
        summary_period: 'Period',
        summary_price: 'Order Amount',
        summary_coupon_applied: 'Coupon',
        summary_subtotal: 'Subtotal',
        membership: 'Membership',
        payment_summary: 'Payment Information',
        payment_atm: 'ATM',
        payment_credit: 'Credit Card',
        payment_method: 'Payment Method',
        invoice_information: 'Invoice Information',
        invoice_title: 'Buyer',
        invoice_sending: 'Invoice Sending',
        invoice_type_no: 'Donate',
        invoice_type_2_copies: '2-Copies',
        invoice_type_3_copies: '3-Copies',
        invoice_company_tax_id: 'Company Tax ID',
        invoice_recipient: 'Recipient Name',
        invoice_phone: 'Phone',
        invoice_address: 'Address',
        invoice_pref_city: 'City',
        invoice_pref_area: 'Area',
        invoice_pref_zip: 'Zipcode',
        invoice_pref_address: 'Address',
        is_current_plan: 'Your current plan',
        contact_us: 'Contact us',
        to: 'to',
        renew_now: 'Renew Now',
        current_membership_type: 'Your membership is {level}',
        regrade_current_membership_type: 'Your membership is <b>{level}</b>',
        upgrade_to_use_this_function: 'Please upgrade to use this function',
        atm_date_adjust_hint: 'Note: Subscription date will be adjusted automatically according to the date of payment.',
        coming_soon: 'Coming soon',
        e_contract: 'Contract Management',
        fb_integration: 'Facebook Messenger Integration',
        embed_button: 'Embed Booking Button',
        more_feature_on_the_way: '...more features on the way',
        embed_button_tips: 'You can place a booking button in your existing website for customer to book directly.',
        fb_integration_tips: 'DING will guide customer to DING booking system to booking your service via Facebook Messenger according to situation.',
        customer_booking_reminder: '1 Day Before Booking Reminder',
        customize_customer_booking_reminder: 'Custom Booking Reminder',
        file_vault: "Customer File Sharing",
        file_vault_content: "{maxSize}/Retain for {retentionMonth} month|{maxSize}/Retain for {retentionMonth} months",
        file_vault_tip: "Manage design/docs/images relating to customer and booking for easier accessing and archiving. Retention period starts after booking ends.",
        customer_points: 'Member Points',
        coupon_available_yearly: '{maxCap} coupons per year',
        promocode_available_yearly: '{maxCap} promocodes per year',
        email_module: 'Send custom emails',
        private_service: 'Private Service',
        fb_customer_chat: 'Facebook Customer Chat Integration',
        line_login_integration: 'Line Login Integration',
        payment_integration: 'Online Payment',
        payment_integration_content: 'TapPay, ECPay, LINE Pay',
        landing_page: 'Landing Page',
        black_list: 'Blacklist Management',
        sms_module: 'SMS Notification',
        line_module: 'LINE Notification',
        interstitial: 'Interstitial Annoucement',
        booking_management: 'Booking Management',
        customer_management: 'Customer Management',
        coupon_management: 'Coupon Management',
        promocode_management: 'Promocode Management',
        email_cap_hint_basic: 'Free 1000 emails/month<small><br>Overage NT$0.05/mail</small><br><small>Effective from 2024/03/01</small>',
        email_cap_hint_standard: 'Free 2000 emails/month<small><br>Overage NT$0.05/mail</small><br><small>Effective from 2024/03/01</small>',
        email_cap_hint_premium: 'Free 3000 emails/month<small><br>Overage NT$0.05/mail</small><br><small>Effective from 2024/03/01</small>',
    },
    contract: {
        save_template: 'Save Template',
        filter_options_placeholder: 'Enter keyword to seach contract templates',
        contract: 'Contract',
        create_new_contract_option: '...Create new contract template',
        create_new_contract_template: 'Create Contract Template',
        create_new_contract_template_hint: 'You can have different contracts.',
        create_new_contract_template_placeholder: 'Contract Title (Only for identification, not visible to customer)',
        you_dont_have_any_contracts_yet: 'You have no contract templates now.',
        create_first: 'Create first one',
        editor_placeholder: 'Enter your contract template...',
        placeholder_customer_name: 'Customer Name',
        placeholder_customer_phone: 'Customer Phone',
        placeholder_customer_email: 'Customer Email',
        placeholder_booking_start_datetime: 'Booking Start DateTime',
        placeholder_booking_end_datetime: 'Booking End DateTime',
        placeholder_booking_service_title: 'Service Title',
        placeholder_provider_name: 'Our Comapny Name',
        placeholder_provider_phone: 'Our Company Phone',
        placeholder_provider_address: 'Our Company Address',
        placeholder_staff_name: 'Staff Name',
        template_saved: 'Template saved',
        template_deleted: 'Template deleted',
        changes_not_saved_sure_to_switch_to_another_contract: 'Changes are not saved yet! Sure to switch to another template?',
        switch: 'Switch',
        contract_template: 'Contract Template',
        e_signing: "E-Signing",
        e_signing_explanation: 'Upload your e-signing image, it will be attached automatically at the bottom of contract generated.',
        no_e_signing_yet: 'No E-Signing Yet.',
        upload_e_signing: 'Upload E-Signing',
        management: 'Contract Management',
        create_new_contract: 'New Contract',
        template_not_selected: 'Template not used',
        select_template_if_needed: 'Select template to generate contract',
        dont_use_template: 'No template',
        status_initiating: 'Initiating',
        status_pending: 'Waiting for signing',
        status_signed: 'Customer Approved',
        loading_contracts: 'Loading...',
        contract_editor_placeholder: 'Enter contract content directly or apply template for fast contract generating',
        contract_content_will_be_reset_after_switch: 'Contract content will be regenerated accoding to selected template, are you sure?',
        preview: 'Preview',
        send_to_customer: 'Send to Customer',
        last_sent_at: 'Sent at {lastSentAt}',
        signed_at: 'Signed at {signedAt} ',
        save: 'Save Draft',
        contract_has_been_sent_for_signing: 'Contract has been sent to customer for signing.',
        hint_for_creating_contract: 'You don\'t have any templates yet. Go to <a href="/b/contracts">Contract Template</a> set up templates for generating contracts easily for future customers.',
        update_name: 'Update Name',
        update_contract_template: 'Update Contract Template',
        update_contract_template_placeholder: 'Please enter new contract template name',
        your_e_signing_is_saved: 'E-Signing saved successfully.',
        please_enter_content: 'Please enter content',
        sure_to_create_new_contract: 'Are you sure to create a new contract? Previous signed/pending contract will be voided. Customer will no be able to view or sign them.',
        contract_saved: 'Contract saved',
        browser_not_support_pdf_embeded: 'Your browser does not support embeded PDF.',
        open_contract_pdf_directly: 'Open contract file in new tab',
		no_contracts_yet: 'No contracts yet.'
    },
    customer_booking_checker: {
        check_booking: 'Check Booking',
        enter_your_booking_id: 'Enter Your Booking ID',
        query: 'Submit',
        no_booking_found: 'No booking found.',
        booking_status_approved: 'Booking approved',
        booking_status_unapproved: 'Requested, not yet approved',
        booking_status_rejected: 'Booking rejected',
        booking_status_cancelled: 'Booking cancelled',
        booking_status_customer_cancelled: 'Booking cancelled by customer',
        sure_to_cancel_booking: 'Are you sure to cancel this booking?',
        sure_to_cancel_booking_with_presets: 'Are you sure to cancel this booking?<br><br<>Bookings created by booking pass will also be cancelled at once.',
        cancel_booking: 'Cancel',
        default_no_cancellation: 'This booking is not cancellable, please contact us. Thanks.',
        default_no_cancellation_anytime_pass_start_datetime: 'Already pass the service start time, cannot cancel.',
        default_no_cancellation_anytime_pass_end_datetime: 'Already pass the service end time, cannot cancel.',
        booking_cancelled: 'Booking cancelled',
        expired: 'Expired',
        reason: 'Reason: ' ,
        contract_already_signed: 'A contract has been signed. Please contact us for cancellation. Thanks',
        booking_pass_cannot_cancel: 'This booking is from a booking pass, cannot cancel.',
    },
    month: {
        '1m': 'Jan',
        '2m': 'Feb',
        '3m': 'Mar',
        '4m': 'Apr',
        '5m': 'May',
        '6m': 'Jun',
        '7m': 'Jul',
        '8m': 'Aug',
        '9m': 'Sep',
        '10m': 'Oct',
        '11m': 'Nov',
        '12m': 'Dec',
    },
    dashboard: {
        monthly_booking_on_services: 'Monthly Booking on Services',
        monthly_booking_on_members: 'Monthly Booking on Members',
        booking: 'Service to provider|Services to provide',
        booking_request: 'Request|Requests',
        visits: 'Landing Visit|Landing Visits',
        bookings_today: 'Today Bookings',
        no_bookings_yet: 'No Bookings',
        period: {
            'week': 'This Week',
            'month': 'This Month',
            'year': 'This Year'
        },
        view_all_in_schedule: 'Check Schedule',
        n_more_bookings: '{count} more',
        upcoming_bookings: 'Upcoming Bookings',
        number_of_bookings: 'Number of Bookings'
    },
    file_vault: {
        invite_customer: 'Share',
        invite_customer_method_1_share_url: 'Copy and Share Url to Customer',
        file_vault_title: 'File Vault',
        this_folder_is_empty: 'It is empty here.',
        root: 'Root',
        upload_file: 'Upload File',
        uploader_type_customer: 'Uploader',
        file_name: 'Name',
        file_size: 'Size',
        uploaded_by: 'Uploader',
        uploaded_at: 'Uploaded At',
        file_type: 'Type',
        new_folder: 'New Folder',
        enter_folder_name: 'Please enter folder name',
        path_back: '〈 Back',
        type_folder: 'Folder',
        grid: 'Grid',
        list: 'List',
        are_you_sure_to_delete: 'Sure to delete {fileName}?',
        invite_customer_message_default: 'You\'ve been invited to start using file vault. Click following button to browse of upload files.',
        url_copied: 'File Vault URL Copied',
        invite_customer_method_2_email_url: 'Sent Invitations to Customers',
        invite_customer_hint: 'Leave message for the customers. For example files you want them to leave and file types/format...etc.',
        default_content: 'Default Content:',
        send_invitation: 'Send Invitation',
        copy_link: 'Copy Link',
        invitation_sent: 'Invitation Sent',
        fail_to_send_invitation: 'Fail to send invitation',
        this_vault_is_cleared_at: 'This file vault is beyond it\'s retention period. Browsing and uploading is not available.',
        retention_hint: 'Content of file vault will be kept for {n} month after booking finished.|Content of file vault will be kept for {n} months after booking finished.',
        file_vault_usage_hint: 'Customer and you can upload any types of files to here for better commynication.',
        rename_file: 'Rename',
        rename_hint: '',
        enter_new_name: 'Please enter new file name',
        this_vault_size_used: 'Vault Space used',
        new_file: 'New',
        fail_to_get_file_vault: 'Fail to get file vault content'
    },
    sms: {
        compose: 'Compose SMS Message',
        template_title: 'Template Title',
        apply_template: 'Apply Template',
        to: 'To',
        body: 'Message',
        send: 'Send',
        choose_from_template: 'Choose Template',
        compose_template: 'Edit Template',
        no_templates_yet: 'No Templates Yet',
        fail_to_send_sms: 'Fail to send message',
        fail_to_send_sms_for_bookings: 'Fail to send message for following bookings:\n {bookings}',
        template_saved: 'Template saved',
        not_sent_successfully: '發送失敗',
        fail_to_send_insufficient_credit: 'Insufficient SMS credit, fail to send message',
        fail_to_update_sms_template: 'Fail to update template',
        fail_to_create_sms_template: 'Fail to create template',
        save_edited_template: 'Save Template',
        save_as_template: 'Save as Template',
        template_delete: 'Delete template {templateName}?',
        enter_template_name: 'Enter template title',
        current_char_count: '{n} character|Total {n} characters / ',
        current_credit_required: '{nCredit} SMS credit|{nCredit} SMS credits',
        message_too_long: 'Total {n} characters. (max message length 333)',
        sms_sending: 'Sending',
        template_title_hint: 'Template Title',
        system_error: "System error, please try again. If this occurs repeatedly, please contact us.",
        fail_to_receive_message: "If you continue to be unable to receive the verification SMS, please refer to the following ways to troubleshoot:<br><br><ol><li>Please ensure that your mobile phone reception is normal and that airplane mode is not activated</li><li>Please check whether there are any ad-blocking apps or internet security software installed on your phone, as these programs may have blacklisted system SMS numbers</li><li>Please check whether the mobile phone's storage has reached its limit</li><li>Please confirm with your telecommunications provider whether you have applied for \"Blocking Corporate SMS Advertising.\" If you have applied for this feature, system numbers may also be blacklisted, preventing receipt of messages</li><li>Please ensure that the mobile number you entered is correct</li><li>Please check if there is any abnormality in your mobile SMS App</li></ol><hr>If you have checked the above items and still cannot receive messages, please contact us to make an appointment, thank you.",
        url_shorten_message: '(The character count is calculated after the system shortens the URL.)',
        continue_without_sms_verification: 'You will be able to continue with the appointment booking, and the system will mark that you have not completed phone number verification.',
    },
    mitake: {
        status_0: 'Sending',
        status_1: 'Has Sent to Telecom',
        status_2: 'Has Sent to Telecom',
        status_4: 'Sent',
        status_5: 'Invalid Message Content',
        status_6: 'Invalid Phone Number',
        status_7: 'SMS Disabled',
        status_8: 'Timeout',
        status_9: 'Cancelled'
    },
    ev8d: {
        status_0: 'Sending',
        status_100: 'Sent',
        status_101: 'Receiver phone not avaiable reported by telecom provider',
        status_102: 'Network system/cellular tower malfunction reported by telecom provider',
        status_103: 'Receiver phone number incorrect or disabled reported by telecom provider',
        status_104: 'Receiver phone number is in black list or it\'s blocking SMS ads',
        status_105: 'Unexpected error occured on receiver phone reported by telecom provider',
        status_106: 'Unexpected error occured reported by telecom provider',
        status_107: 'Receiver phone not opened/bad signal/malfunction SMS module reported by telecom provider',
        status_300: 'SMS scheduled',
        status_303: 'SMS schedule cancelled',
        status_500: 'International SMS is not supported',
        status_501: 'Receiver phone number does not accept WAP',
        'status_-1': 'Error -1',
        'status_-2': 'Error -2',
        'status_-3': 'Error -3',
        'status_-4': 'Error -4',
        'status_-5': 'Error -5',
        'status_-6': 'Error -6'
    },
    country: {
        taiwan: 'Taiwan',
        hongkong: 'Hong Kong'
    },
	payments: {
        pending_item: "Pending - {method} ${amount}",
        paid_item: "Paid ${amount}",
        expired_item: "Expired ${amount}",
        failed_item: "Failed ${amount}",
        cancelled_item: "Cancelled ${amount}",
		payment: 'Payment',
		no_payments_yet: 'No payments yet.',
        "status_PAID": "Paid",
        "status_PENDING": "Pending",
        "status_EXPIRED": "Expired",
        "status_FAILED": "Failed",
        "status_CANCELLED": "Cancelled",
		pending_summary: '${sum} Unpaid',
		paid_summary: '${sum} Paid',
		expired_summary: '${sum} Expired',
		cancelled_summary: '${sum} Cancelled',
        collected_at: '${amount} Collected At {collected_at}'
	},
	item: {
        should_count_for_free_logistic_rule: 'Count into free shipping rule',
        all: 'All',
        renting_charge_type_per_booking: 'Per Booking',
        renting_charge_type_per_day: 'Per Day',
        renting_charge_amount_placeholder: 'Charge Amount',
        renting_charge_type_per_night: 'Per Night',
        renting_charge_type_per_hour: 'Per Hour',
        renting_charge_type: 'Charge',
        show_stock_info: 'Show Stock',
        total_count: "Total",
        total_count_per_day: 'Total/Day',
        n_left: '({n} left)',
		min_per_order_n: "Min {n} required",
		max_per_order_n: "Max purchasable {n} ",
		no_category: "None",
		price: "Price",
		category: "Category",
		status: "Status",
		visible: "Visible",
		hidden: "Hidden",
		title: "Title",
		stock: "Stock",
		spec_title: "Spec Title",
		max_per_order: "Max per order",
		max_per_day: "Max per day",
        min_per_order: "Min per order",
		image: "Image",
        logistics: 'Logistics',
		renting_charge: "${amount}/{unit}",
        renting_charge_unit_BOOKING: 'booking',
        renting_charge_unit_DAY: 'day',
        renting_charge_unit_NIGHT: 'night',
        renting_charge_unit_HOUR: 'hour',
        is_for_renting: 'Renting Type Product',
        is_for_renting_hint: 'System will management availability of renting type product to help stock controlling.',
        default_renting_return_time: 'On last renting day, product should be returned at ',
        fixed_date_time: 'Fixed date time',
        points_deductable: 'Can pay with points',
        auto_hidden_when_expired: 'Auto hidden if overdue',
	},
	orders: {
		booking_order_items: 'Order Items',
		no_booking_order_items: 'No items',
        logistics: 'Logistics',
	},
    logistics: {
        type_HOME_DELIVERY: "Deliver to Home",
        type_FREE_OR_SELF_TAKEN: "Self-Taken",
        type_BOOK_DELIVERY: "Book Delivery",
        area_TAIWAN: "Taiwan",
        area_OFF_ISLAND: "Off Islands",
        area_NONE: "N/A",
        logistic_FIXED: "Fixed",
        logistic_BY_AMOUNT: "By cart amount",
        logistic_BY_COUNT: "By item count",
        logistic_BY_WEIGHT: "By weight",
        payment_PAYMENT_GATEWAY: "Payment Integration",
        payment_MANUAL: "Collect Manually",
        condition_NORMAL: "Normal",
        condition_COLD: "Cold",
        condition_FROZEN: "Frozen",
        rule_FIXED: "Fixed",
        rule_BY_WEIGHT: "By Weight",
        rule_BY_AMOUNT: "By Total Amount",
        rule_BY_COUNT: "By Item Count",
        rule_title_FIXED: "Fixed Amount",
        rule_title_BY_WEIGHT: "Order Weight Total",
        rule_title_BY_AMOUNT: "Order Total Amount",
        rule_title_BY_COUNT: "Order Item Count",
        status_pending: "Preparing/Pending",
        status_shipped: "Shipped",
        status_delivered: "Delivered",
        shipped_at: "Shipped At {shippedAt}",
        trade_no: "Logistic Provider No.",
        free_shipping_for_order_amount: "Free shipping for order amount {amount}+",
        free_shipping_for_count: "Free shipping for order {count}+ item(s)",
    },
    offers: {
        type_PROMO_CODE: 'Promo Code',
        type_COUPON: 'Coupon',
        rule_FIXED_AMOUNT: 'Fixed Amount',
        rule_PERCENTAGE: 'Percentage',
    },
    gateway: {
        ecpay: "ECPay",
        linepay: "LINE Pay",
        tappay: "TapPay",
        manual: "Collect Manually",
        atm: "Bank Transfer",
        atm_info: "Bank Transfer Info"
    },
    sold_out: 'Sold Out',
    tcat: {
        unset: 'Unspecified TCAT package',
        size_1: 'TCAT 60cm',
        size_2: 'TCAT 90cm',
        size_3: 'TCAT 120cm',
        size_4: 'TCAT 150cm',
    },
    tcat_size: 'TCat Size',
    tcat_size_select_hint: 'TCat Size',
    customer_points: {
        login_module_is_required_for_member_points: "Please enable \"Customer Login\" function to allow customers loggin in to check and spend their points!",
        go_set: "Go Enable"
    },
    campaigns: {
        rule_FIXED_AMOUNT: 'Fixed Amount',
        rule_PERCENTAGE: 'Percentage',
        campaigns: 'Campaigns',
    },
    youtube_form: {
        add_new_video: "New Youtube Video",
        please_enter_youtube_video_link: "Please enter url of your youtube video",
        please_enter_valid_youtube_url: "Entered url is not valid youtube link",
        enter_description: "Enter description for this video(optional)"
    },
    customer_notifications: {
        booking_related: 'Booking Related',
        payment_related: 'Payment Related',
        logistic_related: 'Logistic Related',
        contract_signing: 'Contract Signing',
        membership_related: 'Membership Related',
        others: 'Other System Functions',
        booking_request: 'Booking Request Sent',
        booking_accepted: 'Booking Request Approved',
        booking_rejected: 'Booking Request Rejected',
        booking_canceled: 'Booking Request Canceled',
        booking_canceled_by_customer: 'Booking Request Canceled By Customer',
        unpaid_booking_order_reminder: 'Notify payment required for orders',
        booking_reminder: 'Booking Reminder',
        booking_survey_request: 'Booking Survey Request',
        payment_request: 'Payment Request',
        payment_paid: 'Payment Received',
        payment_canceled: 'Payment Cancelled',
        payment_expire_reminder: 'Payment Will Expire Reminder',
        order_shipped: 'Logistic Shipped',
        contract_signing_request: 'Contract Signing Request',
        contract_signed: 'Contract Signed',
        coupon_sent: 'Coupon Sent',
        member_points_sent: 'Member Points Sent',
        customer_level_changed: 'Membership Changed',
        customer_level_renewed: 'Membership Renewed',
        customer_level_expire_reminder: 'Membership Will Expire Reminder',
        file_vault_invitation: 'File Vault Invitation Sent',
    },
    booking_passes: {
        related_passes: 'Available Booking Passes',
        preset_count_exceeds_number_of_redeem: 'Number of presets cannot be more than number of redeem',
        buy_pass: 'Buy This Pass',
        available_passes: 'Available Passes',
        buy_pass: 'Buy This Pass',
        booking_to_activate_when_purchased: 'Following Bookings Included In This Pass',
        preset_service_and_member_user_required: 'Service and staff must be selected to add more presets',
        preset_start_datetime_required: 'Start date and time must be selected to save presets',
        preset_service_required: 'Service must be selected to save presets',
        preset_member_user_required: 'Member must be selected to save presets',
        no_item_spec_selected_yet: 'No Item/Spec Selected',
        confirm_presets_before_booking: '<hr>There\'s booking pass {bookingPassTitle} in the cart, we will book {serviceTitle} on {datetimes} for you automatically.',
        sold_out: 'Sold Out',
        no_bookings: 'No Bookings Yet',
        service: "Service",
        status: "Status",
    },
    customer_table: {
        customer_list: 'Customer List',
        no_customers_yet: 'No customers yet',
        name: 'Name',
        level: 'Level',
        contact: 'Contact',
        tags: 'Tags',
        note: 'Note',
        actions: 'Actions',
    },
    blocked_customers: {
        permanently_blocked: 'Permanently Blocked',
        customer_blocked_until: 'Blocked until {datetime}',
    },
    item_inline_price_editor: {
        n_specs_detail_hidden: '{n} spec included|{n} specs included',
    },
    binding_information: {
        unbind: 'Unbind',
    },
    rich_editor: {
        bold: 'Bold',
        italic: 'Italic',
        underline: 'Underline',
        align_left: 'Align Left',
        align_center: 'Align Center',
        align_right: 'Align Right',
        align_justify: 'Align Justify',
        text_alignments: 'Text Alignments',
        font_size: 'Font Size',
        font_family: 'Font Family',
        system_font_family: 'System Font',
        default_font_size: 'Default Font Size',
        font_color: 'Font Color',
        background_color: 'Background Color',
    },
    link_editor: {
        title: 'Insert Link',
        url: 'URL',
        open_as: 'Open as...',
        new_tab: 'New Tab',
        current_tab: 'Current Tab',
        text: 'Text',
    },
}
